import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UploadHistory } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetMatterUploadHistory = (matterId: string, options?: { refetchInterval?: number | false }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UploadHistory[]>(
    [QueryEntity.UploadHistory, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/history`, fetchConfigGET);
      if (!res.ok) throw new Error(`Failed to fetch upload history: ${res.status}`);
      return res.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
      refetchInterval: options?.refetchInterval ?? false,
    },
  );
};
